<template>
  <div class="banner-factoid">
    <FactoidWrapper
      v-if="profile"
      :key="profile?.step"
      :api-url="apiUrl"
      :sogu-url="soguUrl"
      :profile="profile"
    />
  </div>
</template>

<script setup lang="ts">
  import { FactoidWrapper, getStepData } from '@experience/profile-factoid-package';
  import { ref, onMounted } from 'vue';
  import { useRuntimeConfig } from 'virtual:runtime-config';
  import type { GetListingBannersItemBannerParamsResponse } from '@/shared/api/experience';
  import type { ContextGeoSubject } from '@/shared/types/geography.ts';
  import { trackEvent } from '@/entities/sogu';

  const { VITE_RUNTIME_API_URL, VITE_RUNTIME_SOGU_SERVICE_URL } = useRuntimeConfig<false>();

  interface Props {
    banner: GetListingBannersItemBannerParamsResponse;
    defaultSoguFields: ContextGeoSubject;
    factoidIsShown: boolean;
  }

  const props = defineProps<Props>();

  const factoidIsShown = useModel(props, 'factoidIsShown');

  const profile = ref();
  const apiUrl = ref(VITE_RUNTIME_API_URL || '/');
  const soguUrl = ref(VITE_RUNTIME_SOGU_SERVICE_URL || '/');

  onMounted(async () => {
    try {
      const { data, isView } = await getStepData();
      profile.value = data;

      factoidIsShown.value = isView ?? false;

      await trackEvent('listing:factoid_card.show', {
        ...props.defaultSoguFields.soguStamp,
      });
    } catch (error) {
      console.error('Failed to load factoid data:', error);
    }
  });
</script>

<style scoped lang="scss">
  :deep(.p-nearest-banner) {
    width: 100%;
    height: 100%;
  }
</style>
